var _path, _path2, _path3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodColoured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4599 4.34836C3.47391 8.95907 -0.229458 17.4955 3.18818 23.415C4.32123 25.3775 6.09472 26.806 8.25047 27.6709L17.5954 36.6373C20.8302 39.6924 26.4535 38.9718 30.9514 36.3282C35.5644 33.617 39.3403 28.6223 37.7229 24.4171C36.1055 20.2118 33.2899 13.0256 33.2899 13.0256C33.5699 10.7975 33.2073 8.62245 32.1079 6.71819C28.6903 0.798672 19.4458 -0.262337 11.4599 4.34836Z",
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9525 36.3273C36.6254 33.052 39.5206 27.4461 37.4191 23.8061C35.3175 20.1661 29.0151 19.8705 23.3421 23.1457C17.6692 26.421 14.7739 32.027 16.8755 35.6669C17.1207 36.0917 17.4231 36.4709 17.7751 36.8042C20.4393 39.3273 25.9415 39.2204 30.9525 36.3273Z",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25038 27.6582C7.57373 26.9983 6.98222 26.2446 6.49482 25.4004C3.07718 19.4808 6.07272 11.3531 13.1855 7.24649C20.2984 3.1399 28.835 4.60956 32.2526 10.5291C32.7129 11.3264 33.0569 12.1637 33.2902 13.0259",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9767,
    cy: 32.2298,
    rx: 4.49687,
    ry: 2.88536,
    transform: "rotate(-30 28.9767 32.2298)",
    stroke: "#2D2926",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodColoured);
export default __webpack_public_path__ + "static/media/pod-coloured.8235833e8a253d8658db13cb9ab39ea4.svg";
export { ForwardRef as ReactComponent };